import { createSlice } from '@reduxjs/toolkit'

export const STEPS = {
  fields: 'FIELDS',
  sign: 'SIGN',
  edit: 'EDIT',
}

const initialState = {
  show: false,
  step: STEPS.fields,
}

const interstitialSlice = createSlice({
  name: 'interstitial',
  initialState,
  reducers: {
    setStep: (state, action) => {
      state.step = action.payload
    },
    open: (state, action) => {
      state.show = true
    },
    close: (state, action) => {
      state.show = false
    },
  },
})

export const { open, close, setStep } = interstitialSlice.actions
export default interstitialSlice.reducer
